export const AbacAppKey = "Crm";

export const defaultUnauthorizedMessage = "Contact your Account Director to access this feature";

/**
 * Used to look up a feature by name. Values must match the `Key` property of the `Feature` entity in the ABAC system.
 */
export const AppFeatureLookup: Record<string, string> = {
  CampaignCandidatesAddedByCampaignReport: "CampaignCandidatesAddedByCampaignReport",
  CampaignDeleteButton: "CampaignDeleteButton",
  CampaignDuplicateButton: "CampaignDuplicateButton",
  CampaignEditButton: "CampaignEditButton",
  CampaignEmailPerformanceByCampaignReport: "CampaignEmailPerformanceByCampaignReport",
  CampaignGetEmbedCodeButton: "CampaignGetEmbedCodeButton",
  CampaignsCreateCampaign: "CampaignsCreateCampaign",
  CampaignsEditCampaign: "CampaignsEditCampaign",
  CampaignsDeleteCampaign: "CampaignsDeleteCampaign",
  CampaignsDuplicateCampaign: "CampaignsDuplicateCampaign",
  CampaignsViewCampaignEmbedScript: "CampaignsViewCampaignEmbedScript",
  CandidatesAddCandidatesToGroup: "CandidatesAddCandidatesToGroup",
  CandidatesCallCandidateAction: "CandidatesCallCandidateAction",
  CandidatesEmailCandidateAction: "CandidatesEmailCandidateAction",
  CandidatesImportCandidatesByCsv: "CandidatesImportCandidatesByCsv",
  CandidatesTextCandidateAction: "CandidatesTextCandidateAction",
  CandidatesViewSingleCandidate: "CandidatesViewSingleCandidate",
  DashboardCandidatesAddedReport: "DashboardCandidatesAddedReport",
  DashboardCandidatesByCampaignReport: "DashboardCandidatesByCampaignReport",
  GroupAddCandidatesToGroupButton: "GroupAddCandidatesToGroupButton",
  GroupCallCandidateAction: "GroupCallCandidateAction",
  GroupEmailCandidateAction: "GroupEmailCandidateAction",
  GroupMessageGroupCampaignButton: "GroupMessageGroupCampaignButton",
  GroupRemoveCandidateAction: "GroupRemoveCandidateAction",
  GroupTextCandidateAction: "GroupTextCandidateAction",
  GroupViewMessageHistoryButton: "GroupViewMessageHistoryButton",
  GroupViewScheduledMessages: "GroupViewScheduledMessages",
  GroupViewSingleCandidate: "GroupViewSingleCandidate",
  GroupsCreateGroup: "GroupsCreateGroup",
  GroupsDeleteGroup: "GroupsDeleteGroup",
  GroupsViewGroupProfile: "GroupsViewGroupProfile",
  ProfileAddCandidateNotes: "ProfileAddCandidateNotes",
  ProfileAddCandidateReviews: "ProfileAddCandidateReviews",
  ProfileCallCandidateAction: "ProfileCallCandidateAction",
  ProfileCandidateLocationLink: "ProfileCandidateLocationLink",
  ProfileDownloadCandidateAttachments: "ProfileDownloadCandidateAttachments",
  ProfileEmailCandidateAction: "ProfileEmailCandidateAction",
  ProfileTextCandidateAction: "ProfileTextCandidateAction",
  ProfileViewCandidateCampaignResponses: "ProfileViewCandidateCampaignResponses",
  ProfileViewCandidateContactInformation: "ProfileViewCandidateContactInformation",
  ProfileViewCandidateUpdateHistory: "ProfileViewCandidateUpdateHistory",
  ProfileVoteOnCandidateReviews: "ProfileVoteOnCandidateReviews",
};
